import React, { useState } from "react";
import styles from "./ActiveBitrixChatBotContainer.module.scss";
import ScreenHeader from "../ScreenHeader/ScreenHeader";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AllInfoContainer } from "./components/AllInfoContainer/AllInfoContainer";
// import { TrashIcon } from "../../assets/icons/TrashIcon";
// import { useNavigate } from "react-router-dom";
import { LoadingComponent } from "../LoadingComponent/LoadingComponent";
import { AllChatsContainer } from "../AllChatsContainer/AllChatsContainer";
import { configureBitrixChatBot } from "../../utils/api/actions/integrations/bitrixBot";
import { setUpdateDataBitrixChatBot } from "../../store/slices/bitrixChatBotSlice";

export const ActiveBitrixChatBotContainer = () => {
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const {
    activeDataBitrixChatBot,
    isUpdateBitrixChatBot,
    updateDataBitrixChatBot,
    isErrorBitrixChatBot,
  } = useSelector((state) => state?.bitrixChatBot);
  // const id =
  //   useSelector((state) => state.user?.data?.id) ||
  //   localStorage.getItem("@storage_User_Id");

  const [activeNav, setActiveNav] = useState("all info");
  const [isLoading] = useState(false);

  const navItems = [
    {
      name: "Общая информация",
      value: "all info",
      component: (
        <AllInfoContainer
          activeBitrix={activeDataBitrixChatBot}
          updateBitrix={isUpdateBitrixChatBot}
          updatedDataBitrix={updateDataBitrixChatBot}
          errorBitrix={isErrorBitrixChatBot}
        />
      ),
    },
    {
      name: "Чаты",
      value: "chats",
      component: (
        <AllChatsContainer categories={activeDataBitrixChatBot?.chats} />
      ),
    },
  ];

  const valueObserver = (e) => {
    e.stopPropagation();
    setActiveNav(e.target.id);
    // dispatch(getIntegrationBitrixBot(id, activeDataBitrixChatBot.id));
  };

  // const handleDelete = () => {
  //   console.log("delete");
  //   navigate("/integration");
  //   // let data = {
  //   //     userId: id,
  //   //     clientId: activeBitrix?.dataUser.clientId,
  //   // };
  //   // dispatch(deleteIntegrationBitrix(data, setIsLoading, navigate));
  // };

  const renderNavItems = (arr) => {
    return arr.map((el, index) => {
      return (
        <div
          key={`vk-${index}`}
          className={
            el.value === activeNav ? styles.activeNavItem : styles.navItem
          }
          id={el.value}
          onClick={valueObserver}
        >
          {el.name}
        </div>
      );
    });
  };

  const renderBodyItems = (arr) => {
    return arr
      .map((item) => {
        if (item.value === activeNav) {
          return <div key={item.value}>{item.component}</div>;
        }
        return null;
      })
      .filter(Boolean);
  };

  const errorEmptyAssistantId = () =>
    toast.error("Выберите ассистента!", {
      toastId: "customId",
    });

  const onCancelEdit = () => {
    dispatch(setUpdateDataBitrixChatBot(null));
  };

  const onSaveUpdatedData = () => {
    if (
      updateDataBitrixChatBot?.assistantId &&
      updateDataBitrixChatBot?.assistantId !==
        "00000000-0000-0000-0000-000000000000"
    ) {
      dispatch(configureBitrixChatBot(updateDataBitrixChatBot));
    } else {
      errorEmptyAssistantId();
    }
  };

  // const actions = [
  //   {
  //     className: styles.deleteButton,
  //     titleClassName: styles.titleDeleteButton,
  //     title: "Удалить",
  //     icon: <TrashIcon width={16} height={18} fill={"#cb3e3e"} />,
  //     onClick: handleDelete,
  //   },
  // ];

  return (
    <div className={styles.container}>
      <ScreenHeader
        onCancelEdit={onCancelEdit}
        onSaveUpdatedData={onSaveUpdatedData}
        isEditing={isUpdateBitrixChatBot}
        title={"Интеграции"}
        path={"/integration"}
        // actions={actions}
      />
      <div className={styles.navContainer}>{renderNavItems(navItems)}</div>
      {isLoading ? (
        <LoadingComponent />
      ) : (
        <>
          <div
            className={styles.body}
            style={{
              height: isErrorBitrixChatBot && "calc(80% - 40px)",
              justifyContent: isErrorBitrixChatBot && "center",
            }}
          >
            {renderBodyItems(navItems)}
          </div>
        </>
      )}
    </div>
  );
};
